import { LfClaims, LfOrg, parseOrgs } from '../lf-claims';

/**
 * Reads the claims out of a login-farmacias access token.
 *
 * `orgs` and `lf_roles` arrive as a plain string when they have one element and as an array when
 * they have more — Entra serialises them that way. The contract's `parseOrgs`/`asList` take both
 * shapes, so nothing is normalised here; never index those claims directly.
 */
export function readLfClaims(accessToken: string): LfClaims {
  return decodePayload(accessToken) as LfClaims;
}

/** The token's orgs, decoded. */
export function readLfOrgs(accessToken: string): LfOrg[] {
  return parseOrgs(readLfClaims(accessToken).orgs);
}

/** Whatever the token calls the signed-in user. */
export function readLfEmail(accessToken: string): string {
  const payload = decodePayload(accessToken) as {
    email?: string;
    preferred_username?: string;
  };
  return payload.email ?? payload.preferred_username ?? '';
}

/**
 * The payload of a JWT, without verifying it. Safe here and only here: the token was handed over
 * by MSAL, and nothing this reads is trusted for a security decision the API does not re-check
 * against the signature. It is read to shape the UI.
 */
function decodePayload(accessToken: string): unknown {
  const segment = accessToken.split('.')[1];
  if (!segment) {
    throw new Error('Not a JWT: no payload segment.');
  }
  return JSON.parse(atob(segment.replace(/-/g, '+').replace(/_/g, '/'))) as unknown;
}
